import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';


@Component({
  selector: 'app-check-licence',
  templateUrl: './check-licence.component.html',
  styleUrls: ['./check-licence.component.scss']
})
export class CheckLicenceComponent extends SubscriptionBaseComponent implements OnInit {

  checkLicenceForm: FormGroup;
  loading = false;
  userIsLink: boolean;


  constructor(
    private dataService: DataService,
    private router: Router,
    private formBuilder: FormBuilder,
    private uiService: UiService,
    private userService: UserService,
    private authService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.initForm();
    this.checkLicenceForm.get('mail').setValue(this.authService.currentUserValue.email);

  }

  back(): void {
    if (localStorage.getItem('url') === '/licence') {
      this.router.navigate(['/licence']);
    }
    if (localStorage.getItem('url') === '/profil') {
      this.router.navigate(['/profil']);
    }
    this.dataService.linkYourAccount.next(false);

  }

  // goLink(): void {
  //   this.router.navigate(['/home']);
  // }

  onSubmit(): void {
    if (this.checkLicenceForm.invalid) {
      this.errorsToManage();
      return;
    }

    const link = {
      email: this.checkLicenceForm.get('mail').value,
      licence: this.checkLicenceForm.get('licence').value
    };

    this.loading = true;


    // setTimeout(() => {
    //   (localStorage.getItem('url') !== '/profil' && localStorage.getItem('url') !== '/licence') ?
    //     this.router.navigate(['/choice-persona']) :
    //     (localStorage.getItem('url') === '/licence') ?
    //       this.router.navigate(['/licence']) :
    //       this.router.navigate(['/profil']);

    //   this.dataService.linkYourAccount.next(false);
    // }, 500);

    this.userService.linkMyAccount(link).subscribe(() => {
      this.dataService.userIsLink.next(true);
      this.dataService.confirmEmailLicence.next(true);

      this.authService.refreshToken().subscribe(() => {

        if (localStorage.getItem('url') === '/profil') {
          this.router.navigate(['/profil']);
        } else {
          if (localStorage.getItem('url') === '/licence') {
            this.router.navigate(['/licence']);
          } else {
            this.router.navigate(['/choice-persona']);
          }
        }

        this.getMenu();
      }, error => {
        if (localStorage.getItem('url') === '/profil') {
          this.router.navigate(['/profil']);
        } else {
          if (localStorage.getItem('url') === '/licence') {
            this.router.navigate(['/licence']);
          } else {
            this.router.navigate(['/choice-persona']);
          }
        }
      });
    }, error => {
      // console.log(error)
      this.loading = false;
      this.uiService.openSnackBar(error.error, '');
    });


  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

  private get f() {
    return this.checkLicenceForm.controls;
  }

  private initForm(): void {
    this.checkLicenceForm = this.formBuilder.group({
      mail: ['', [Validators.required, Validators.email]],
      licence: ['', Validators.required]
    });
  }

  private errorsToManage(): void {
    const mail = this.f.mail.errors?.required;
    const licence = this.f.licence.errors?.required;
    const check = (mail && licence);

    if (check) {
      this.uiService.openSnackBar(`Les champs sont vides`, '');
    } else {
      if (mail) { this.uiService.openSnackBar(`Champ email requis`, ''); }
      if (licence) { this.uiService.openSnackBar(`Champ licence requis`, ''); }
      if (!this.f.mail.valid) { this.uiService.openSnackBar(`Email invalide`, ''); }
    }
  }



  private initSub(): void {
    this.subscription

      .add(
        this.dataService.userIsLink.asObservable().subscribe(link => {
          this.userIsLink = link;

          if (this.userIsLink) {
            this.router.navigate(['/profil']);
          }
        })
      );

  }



}
